import { render, staticRenderFns } from "./IELTSForm.vue?vue&type=template&id=500488ba&"
import script from "./IELTSForm.vue?vue&type=script&lang=js&"
export * from "./IELTSForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports